// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const hitchingPost = defineModel({
  id: "hitching-post",
  batchId: "future",
  name: "Hitching post",
  tags: ["scenery","hitching","post","low-poly","age-of-mcp","future"],
  summary: "A post to tie up draught animals while loading.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.25,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.05, 0.06, 0.62, 7), color: "#6e4f2e", position: [0, 0.31, 0] },
      { geometry: new THREE.BoxGeometry(0.4, 0.05, 0.05), color: "#8a6840", position: [0, 0.54, 0] },
      { geometry: new THREE.TorusGeometry(0.05, 0.012, 4, 10), color: "#4a4540", position: [0, 0.42, 0.06], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.06, 0.012, 4, 10, 3.141593), color: "#b9a574", position: [0.12, 0.34, 0.06], rotation: [0, 0, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.065, 0.06, 0.05, 7), color: "#563d22", position: [0, 0.62, 0] },
    ],
  animations: [],
});
